<template>
  <div class="balance-user" :style="{ '--height': height, }">
    <div class="index-view-top">
      <van-icon @click="toBack" name="arrow-left" size="28" color="#ffffff" />
      <div class="title">{{ $t("head.lotteryRecord") }}</div>
      <van-icon style="opacity: 0" name="ellipsis" size="28" color="#ffffff" />
    </div>
    <div class="details-lists" style="height:3rem;padding: 0 0.9375rem;">
      <div style="text-align: center;">{{ $t("lotteryRecord.block") }}</div>
      <div style="text-align: center;">Hash</div>
      <div class="result-title" v-if="matchType == 'A1'" style="text-align: center;flex:5">
        <!-- {{ $t("lotteryRecord.results_of") }} -->
        <div>
          <p>{{ $t("entertainment.daxiao") }}</p>
        </div>
        <div>
          <p>{{ $t("entertainment.single") }}{{ $t("entertainment.double") }}</p>
        </div>
        <div>
          <p>{{ $t("entertainment.champion") }}</p>
        </div>
      </div>
      <div class="result-title" v-if="matchType == 'A2'" style="text-align: center;flex:5">
        <!-- {{ $t("lotteryRecord.results_of") }} -->
        <div>
          <p>{{ $t("entertainment.champion") }}</p>
        </div>
        <div>
          <p>{{ $t("entertainment.yajun") }}</p>
        </div>
        <div>
          <p>{{ $t("entertainment.he") }}</p>
        </div>
      </div>
      <div class="result-title" v-if="matchType == 'A3'" style="text-align: center;flex:5">
        <!-- {{ $t("lotteryRecord.results_of") }} -->
        <div>
          <p>{{ $t("entertainment.champion") }}</p>
        </div>
        <div>
          <p>{{ $t("entertainment.yajun") }}</p>
        </div>
        <div>
          <p>{{ $t("entertainment.both_sides") }}</p>
        </div>
        <div>
          <p>{{ $t("entertainment.he") }}</p>
        </div>
      </div>
      <div class="result-title" v-if="matchType == 'A4'" style="text-align: center;flex:5">
        <!-- {{ $t("lotteryRecord.results_of") }} -->
        <div>
          <p>{{ $t("entertainment.daxiao") }}</p>
        </div>
        <div>
          <p>{{ $t("entertainment.single") }}{{ $t("entertainment.double") }}</p>
        </div>
        <div>
          <p>{{ $t("history.results_of") }}</p>
        </div>
      </div>
      <div class="result-title" v-if="matchType == 'A5'" style="text-align: center;flex:5">
        <!-- {{ $t("lotteryRecord.results_of") }} -->
        <div>
          <p>{{ $t("entertainment.combination") }}</p>
        </div>
      </div>
      <div class="result-title" v-if="matchType == 'A6'" style="text-align: center;flex:5">
        <!-- {{ $t("lotteryRecord.results_of") }} -->
        <div>
          <p>{{ $t("entertainment.dragon") }}</p>
        </div>
        <div>
          <p>{{ $t("entertainment.tiger") }}</p>
        </div>
        <div>
          <p>{{ $t("history.results_of") }}</p>
        </div>
      </div>
      <div class="result-title" v-if="matchType == 'A7'" style="text-align: center;flex:5">
        <!-- {{ $t("lotteryRecord.results_of") }} -->
        <div>
          <p>{{ $t("entertainment.zhuang") }}</p>
        </div>
        <div>
          <p>{{ $t("entertainment.idle") }}</p>
        </div>
        <div>
          <p>{{ $t("history.results_of") }}</p>
        </div>
      </div>
      <div class="result-title" v-if="matchType == 'A8'" style="text-align: center;flex:5">
        <!-- {{ $t("lotteryRecord.results_of") }} -->
        <div>
          <p>{{ $t("history.results_of") }}</p>
        </div>
      </div>
    </div>

    <ul class="infinite-list" v-infinite-scroll="load" style="overflow: auto">

      <div v-if="matchType == 'A6'">
        <div class="details-lists" v-for="(item, index) in number" :key="index">
          <div style="text-align: center;" @click="toBlock(item.height)">{{ item.height }}</div>
          <div style="text-align: center;">
            <p v-for="(item2, index2) in item.blockhash" :key="index2"
              :class="item2.colorred == true ? 'colorred' : item2.colorblue == true ? 'colorblue' : ''">
              {{ item2.number }}</p>
          </div>
          <div class="result" style="flex:5">
            <div>
              <p>{{ item.lotteryResult.split(',')[0] }}</p>
            </div>
            <div>
              <p style="color: #1F49BE;">{{ item.lotteryResult.split(',')[1] }}</p>
            </div>
            <div>
              <p
                :class="item.resultValue[0] == 'A601' ? 'colorred' : item.resultValue[0] == 'A602' ? 'colorblue' : 'colorgreen'">
                {{
                    matchInfo[item.resultValue[0]] || ''
                }}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="matchType == 'A7'">
        <div class="details-lists" v-for="(item, index) in number" :key="index">
          <div style="text-align: center;" @click="toBlock(item.height)">{{ item.height }}</div>
          <div style="text-align: center;">
            <p v-for="(item2, index2) in item.blockhash" :key="index2"
              :class="index2 == '9' ? 'colorblue' : index2 == '8' ? 'colorblue' : index2 == '6' ? 'colorred' : index2 == '5' ? 'colorred' : ''">
              {{ item2.number }}</p>
          </div>
          <div class="result" style="flex:5">
            <div>
              <p>{{ item.lotteryResult.split(',')[0] }}</p>
            </div>
            <div>
              <p style="color: #1F49BE;">{{ item.lotteryResult.split(',')[1] }}</p>
            </div>
            <div>
              <p
                :class="item.resultValue[0] == 'A701' ? 'colorred' : item.resultValue[0] == 'A702' ? 'colorblue' : 'colorgreen'">
                {{
                    matchInfo[item.resultValue[0]] || ''
                }}</p>
            </div>
          </div>
        </div>
      </div>
      <!--  (item2 == item.lotteryResult.split(',')[0] ? 'colorred' : item2 == item.lotteryResult.split(',')[1] ? 'colorblue' : '')-->
      <div v-else>
        <div class="details-lists" v-for="(item, index) in number" :key="index">
          <div style="text-align: center;" @click="toBlock(item.height)">{{ item.height }}</div>
          <div style="text-align: center;">
            <p v-for="(item2, index2) in item.blockhash" :key="index2"
              :class="item2.colorred == true ? 'colorred' : item2.colorblue == true ? 'colorblue' : ''">
              {{ item2.number }}</p>
          </div>
          <div class="result" style="flex:5" v-if="matchType == 'A1'">
            <div v-for="(item1, index1) in item.resultValue" :key="index1">
              <p
                :class="item1 == 'A101' ? 'colorred' : item1 == 'A102' ? 'colorblue' : (item1 == 'A103' ? 'colorred' : item1 == 'A104' ? 'colorblue' : '')">
                {{
                    matchInfo[item1] ? matchInfo[item1].split('-')[1] : ''
                }}</p>
            </div>
          </div>
          <div class="result" style="flex:5" v-if="matchType == 'A2'">
            <div>
              <p style="color: #B51717;">{{ matchInfo[item.resultValue[0]] ?
                  matchInfo[item.resultValue[0]].split('-')[1] : ''
              }}</p>
            </div>
            <div>
              <p style="color: #1F49BE;">{{ matchInfo[item.resultValue[1]] ?
                  matchInfo[item.resultValue[1]].split('-')[1] : ''
              }}</p>
            </div>
            <div>
              <p style="color:green">{{ matchInfo[item.resultValue[2]] ? matchInfo[item.resultValue[2]].split('-')[1] :
                  ''
              }}</p>
            </div>
          </div>
          <div class="result" style="flex:5" v-if="matchType == 'A3'">
            <div>
              <p style="color: #B51717;">{{
                  item.lotteryResult.split(',')[0] || ''
              }}</p>
            </div>
            <div>
              <p style="color: #1F49BE;">{{ item.lotteryResult.split(',')[1] || ''
              }}</p>
            </div>
            <div>
              <p
                :class="item.resultValue[3] == 'A315' ? 'colorred' : item.resultValue[3] == 'A316' ? 'colorblue' : (item.resultValue[3] == 'A317' ? 'colorred' : item.resultValue[3] == 'A318' ? 'colorblue' : '')">
                {{ matchInfo[item.resultValue[3]] || ''
                }}</p>
              <p
                :class="item.resultValue[4] == 'A315' ? 'colorred' : item.resultValue[4] == 'A316' ? 'colorblue' : (item.resultValue[4] == 'A317' ? 'colorred' : item.resultValue[4] == 'A318' ? 'colorblue' : '')">
                {{ matchInfo[item.resultValue[4]] || ''
                }}</p>
            </div>
            <div>
              <p
                :class="item.resultValue[1] == 'A311' ? 'colorred' : item.resultValue[1] == 'A312' ? 'colorblue' : (item.resultValue[1] == 'A313' ? 'colorred' : item.resultValue[1] == 'A314' ? 'colorblue' : '')">
                {{ matchInfo[item.resultValue[1]] || ''
                }}</p>
              <p
                :class="item.resultValue[2] == 'A311' ? 'colorred' : item.resultValue[2] == 'A312' ? 'colorblue' : (item.resultValue[2] == 'A313' ? 'colorred' : item.resultValue[2] == 'A314' ? 'colorblue' : '')">
                {{ matchInfo[item.resultValue[2]] || ''
                }}</p>
            </div>
          </div>
          <div class="result" style="flex:5" v-if="matchType == 'A4'">
            <div>
              <p
                :class="item.resultValue[0] == 'A401' ? 'colorred' : item.resultValue[0] == 'A402' ? 'colorblue' : (item.resultValue[0] == 'A403' ? 'colorred' : item.resultValue[0] == 'A404' ? 'colorblue' : '')">
                {{
                    matchInfo[item.resultValue[0]] || ''
                }}</p>
            </div>
            <div>
              <p
                :class="item.resultValue[1] == 'A401' ? 'colorred' : item.resultValue[1] == 'A402' ? 'colorblue' : (item.resultValue[1] == 'A403' ? 'colorred' : item.resultValue[1] == 'A404' ? 'colorblue' : '')">
                {{ matchInfo[item.resultValue[1]] || ''
                }}</p>
            </div>
            <div>
              <p style="color:#B51717">{{ item.lotteryResult || ''
              }}</p>
            </div>
          </div>
          <div class="result" style="flex:5" v-if="matchType == 'A5'">
            <div>
              <p
                :class="item.resultValue[0] == 'A501' ? 'colorred' : item.resultValue[0] == 'A502' ? 'colorblue' : (item.resultValue[0] == 'A503' ? 'colorred' : item.resultValue[0] == 'A504' ? 'colorblue' : '')">
                {{ matchInfo[item.resultValue[0]] || ''
                }}</p>
            </div>
          </div>
          <div class="result" style="flex:5" v-if="matchType == 'A8'">
            <div>
              <p style="color:#B51717">{{ matchInfo[item.resultValue[0]] || ''
              }}</p>
            </div>
          </div>
        </div>
      </div>
    </ul>
  </div>
</template>

<script>
import { racingPeriodList } from '@/utils/request'
export default {
  data() {
    return {
      number: '',
      current: 1,
      height: '', //屏幕高度
      matchType: 'A1', //1:哈希赛车 2：哈希快艇 3：两面  4：组合 5：哈希赛马 6：龙虎合 7：百家乐 8:独胆
      matchInfo: {
        B101: this.$t('entertainment.big'),
        B102: this.$t('entertainment.small'),
        B103: this.$t('entertainment.single'),
        B104: this.$t('entertainment.double'),
        B201: this.$t('entertainment.forlarge'),
        B202: this.$t('entertainment.smallsingle'),
        B203: this.$t('entertainment.large_double'),
        B204: this.$t('entertainment.small_double'),
        B301: this.$t('entertainment.dragon'),
        B302: this.$t('entertainment.tiger'),
        B303: this.$t('entertainment.us'),
        B401: this.$t('entertainment.zhuang'),
        B402: this.$t('entertainment.idle'),
        B403: this.$t('entertainment.he'),
        B501: '1',
        B502: '2',
        B503: '3',
        B504: '4',
        B505: '5',
        B506: '6',
        B507: '7',
        B508: '8',
        B509: '9',
        B510: '0',
        A101: this.$t('entertainment.both_sides') + '-' + this.$t('entertainment.big'),
        A102: this.$t('entertainment.both_sides') + '-' + this.$t('entertainment.small'),
        A103: this.$t('entertainment.both_sides') + '-' + this.$t('entertainment.single'),
        A104: this.$t('entertainment.both_sides') + '-' + this.$t('entertainment.double'),
        A110: this.$t('entertainment.champion') + '-1',
        A111: this.$t('entertainment.champion') + '-2',
        A112: this.$t('entertainment.champion') + '-3',
        A113: this.$t('entertainment.champion') + '-4',
        A114: this.$t('entertainment.champion') + '-5',
        A115: this.$t('entertainment.champion') + '-6',
        A116: this.$t('entertainment.champion') + '-7',
        A117: this.$t('entertainment.champion') + '-8',
        A118: this.$t('entertainment.champion') + '-9',
        A119: this.$t('entertainment.champion') + '-10',
        A201: this.$t('entertainment.champion') + '-1',
        A202: this.$t('entertainment.champion') + '-2',
        A203: this.$t('entertainment.champion') + '-3',
        A204: this.$t('entertainment.champion') + '-4',
        A205: this.$t('entertainment.champion') + '-5',
        A206: this.$t('entertainment.champion') + '-6',
        A207: this.$t('entertainment.champion') + '-7',
        A208: this.$t('entertainment.champion') + '-8',
        A209: this.$t('entertainment.champion') + '-9',
        A210: this.$t('entertainment.champion') + '-10',
        A211: this.$t('entertainment.yajun') + '-1',
        A212: this.$t('entertainment.yajun') + '-2',
        A213: this.$t('entertainment.yajun') + '-3',
        A214: this.$t('entertainment.yajun') + '-4',
        A215: this.$t('entertainment.yajun') + '-5',
        A216: this.$t('entertainment.yajun') + '-6',
        A217: this.$t('entertainment.yajun') + '-7',
        A218: this.$t('entertainment.yajun') + '-8',
        A219: this.$t('entertainment.yajun') + '-9',
        A220: this.$t('entertainment.yajun') + '-10',
        A221: this.$t('entertainment.he') + '-3',
        A222: this.$t('entertainment.he') + '-4',
        A223: this.$t('entertainment.he') + '-5',
        A224: this.$t('entertainment.he') + '-6',
        A225: this.$t('entertainment.he') + '-7',
        A226: this.$t('entertainment.he') + '-8',
        A227: this.$t('entertainment.he') + '-9',
        A228: this.$t('entertainment.he') + '-10',
        A229: this.$t('entertainment.he') + '-11',
        A230: this.$t('entertainment.he') + '-12',
        A231: this.$t('entertainment.he') + '-13',
        A232: this.$t('entertainment.he') + '-14',
        A233: this.$t('entertainment.he') + '-15',
        A234: this.$t('entertainment.he') + '-16',
        A235: this.$t('entertainment.he') + '-17',
        A236: this.$t('entertainment.he') + '-18',
        A237: this.$t('entertainment.he') + '-19',
        A301: this.$t('entertainment.champion_one_size') + '-1',
        A302: this.$t('entertainment.champion_one_size') + '-2',
        A303: this.$t('entertainment.champion_one_size') + '-3',
        A304: this.$t('entertainment.champion_one_size') + '-4',
        A305: this.$t('entertainment.champion_one_size') + '-5',
        A306: this.$t('entertainment.champion_one_size') + '-6',
        A307: this.$t('entertainment.champion_one_size') + '-7',
        A308: this.$t('entertainment.champion_one_size') + '-8',
        A309: this.$t('entertainment.champion_one_size') + '-9',
        A310: this.$t('entertainment.champion_one_size') + '-10',
        A311: this.$t('entertainment.andbig'),
        A312: this.$t('entertainment.andsmall'),
        A313: this.$t('entertainment.andsingle'),
        A314: this.$t('entertainment.anddouble'),
        A315: this.$t('entertainment.big'),
        A316: this.$t('entertainment.small'),
        A317: this.$t('entertainment.single'),
        A318: this.$t('entertainment.double'),
        A401: this.$t('entertainment.big'),
        A402: this.$t('entertainment.small'),
        A403: this.$t('entertainment.single'),
        A404: this.$t('entertainment.double'),
        A501: this.$t('entertainment.forlarge'),
        A502: this.$t('entertainment.smallsingle'),
        A503: this.$t('entertainment.large_double'),
        A504: this.$t('entertainment.small_double'),
        A601: this.$t('entertainment.dragon'),
        A602: this.$t('entertainment.tiger'),
        A603: this.$t('entertainment.us'),
        A701: this.$t('entertainment.zhuang'),
        A702: this.$t('entertainment.idle'),
        A703: this.$t('entertainment.us'),
        A801: '1',
        A802: '2',
        A803: '3',
        A804: '4',
        A805: '5',
        A806: '6',
        A807: '7',
        A808: '8',
        A809: '9',
        A810: '0'
      }
    }
  },
  created() {
    let h = document.documentElement.clientHeight || document.body.clientHeight;
    if (h > 0) {
      this.height = h + 'px' //页面高度
    } else {
      this.height = "100vh"
    }
  },
  mounted() {
    this.matchType = this.$route.query.type
    this.getUserInfo()
  },
  methods: {
    toBlock(item) {
      window.open('https://tronscan.io/#/block/' + item, '_blank')
    },
    getUserInfo() {
      racingPeriodList({
        type: this.matchType,
        current: this.current,
        size: 10
      }).then(res => {
        if (res.code == '200') {
          res.data.records.map((item, index) => {
            let blockhash = item.blockhash.slice(item.blockhash.length - 10, item.blockhash.length).split('')
            let temp = [
              { number: '', colorred: false, colorblue: false },
              { number: '', colorred: false, colorblue: false },
              { number: '', colorred: false, colorblue: false },
              { number: '', colorred: false, colorblue: false },
              { number: '', colorred: false, colorblue: false },
              { number: '', colorred: false, colorblue: false },
              { number: '', colorred: false, colorblue: false },
              { number: '', colorred: false, colorblue: false },
              { number: '', colorred: false, colorblue: false },
              { number: '', colorred: false, colorblue: false }
            ]
            for (let i = 0; i < blockhash.length; i++) {
              temp[i].number = blockhash[i]
              temp[i].colorred = false
              temp[i].colorblue = false
            }
            let red = 0
            let blue = 0
            for (let i = blockhash.length - 1; i > 0; i--) {
              if (blockhash[i] == item.lotteryResult.split(',')[0]) {
                if (red == 0) {
                  temp[i].colorred = true
                  red = 1
                }
              } else if (blockhash[i] == '0' && item.lotteryResult.split(',')[0] == '10') {
                if (red == 0) {
                  temp[i].colorred = true
                  red = 1
                }
              }
              if (blockhash[i] == item.lotteryResult.split(',')[1]) {
                if (blue == 0 && temp[i].colorred != true) {
                  temp[i].colorblue = true
                  blue = 1
                }
              } else if (blockhash[i] == '0' && item.lotteryResult.split(',')[0] == '10') {
                if (blue == 0 && temp[i].colorred != true) {
                  temp[i].colorblue = true
                  blue = 1
                }
              }
            }
            item.blockhash = temp
            item.resultValue = item.resultValue.split(',')
            if (index == res.data.records.length - 1) {
              this.number = res.data.records
            }
          })
        }
      })
    },
    toNoticeDetails() {
      this.$router.push('/noticeDetails')
    },
    load() {
      // racingPeriodList({
      //   type: this.matchType,
      //   current: this.current + 1,
      //   size: 10,
      // }).then((res) => {
      //   if (res.code == "200") {
      //     if (res.data.records.length > 0) {
      //       this.current += 1
      //       res.data.records.map((item) => {
      //         item.resultValue = item.resultValue.split(',')
      //       })
      //       this.number = [...this.number, ...res.data.records]
      //     }
      //   }
      // });
    },
    toBack() {
      this.$router.go('-1')
    }
  }
}
</script>

<style lang="scss" scoped>
.balance-user {
  width: 100vw;
  height: var(--height);
  background: #020017;

  .infinite-list {
    height: calc(var(--height) - 6.75rem);
    padding: 0 0.9375rem;
  }

  .colorred {
    color: #b51717 !important;
  }

  .colorblue {
    color: #1f49be !important;
  }

  .colorgreen {
    color: green !important;
  }

  .details-lists {
    min-height: 2.9375rem;
    display: flex;
    border-bottom: 0.0625rem solid #272727;
    align-items: center;

    .result-title {
      display: flex;

      >div {
        flex: 1;
      }
    }

    .result {
      display: flex;

      >div {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        >p {
          color: #b51717;
        }
      }
    }

    >div {
      flex: 3;
      font-size: 0.75rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #999999;
      text-align: center;
      display: flex;
      justify-content: center;
    }
  }

  .index-view-top {
    height: 3.625rem;
    padding: 0 0.9375rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      font-size: 1.125rem;
      font-family: PingFang SC-Bold, PingFang SC;
      font-weight: bold;
      color: #ffffff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/help/lotteryRecord.vue